import React from 'react';
import { Box } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ConsultationTypesSection from '../components/ConsultationTypesSection';
import CenterInfoSection from '../components/CenterInfoSection';

const ConsultationsPage = () => {
  return (
    <Box>
      <Header />
      <ConsultationTypesSection />
      <CenterInfoSection />
      <Footer />
    </Box>
  );
};

export default ConsultationsPage;
